import React from "react";
import { Pagination } from "react-bootstrap";

const PaginationComponent = ({ totalPages, isMobile, setCurrentPage, currentPage, t, tItemName, indexOfFirst, indexOfLast, lengthTotal }) => {

    if (totalPages <= 1) return null;

    const pageOffset = isMobile ? 0 : 1; // Menos páginas visíveis no mobile
    const showAll = totalPages <= (isMobile ? 3 : 4); // Menos páginas para mostrar todas no mobile

    return (
        <div className="mt-3">
            <Pagination className={`justify-content-center mb-0`}>
                {/* Navegação simplificada para mobile */}
                {isMobile ? (
                    <>
                        <Pagination.First
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1} />

                        <Pagination.Prev
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1} />

                        <Pagination.Item active>
                            {currentPage} / {totalPages}
                        </Pagination.Item>

                        <Pagination.Next
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages} />

                        <Pagination.Last
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages} />
                    </>
                ) : (
                    <>
                        {/* Navegação completa para desktop */}
                        <Pagination.First
                            onClick={() => setCurrentPage(1)}
                            disabled={currentPage === 1} />
                        <Pagination.Prev
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1} />

                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => {
                            if (showAll ||
                                pageNumber === 1 ||
                                pageNumber === totalPages ||
                                (pageNumber >= currentPage - pageOffset &&
                                    pageNumber <= currentPage + pageOffset)) {
                                return (
                                    <Pagination.Item
                                        key={pageNumber}
                                        active={pageNumber === currentPage}
                                        onClick={() => setCurrentPage(pageNumber)}
                                    >
                                        {pageNumber}
                                    </Pagination.Item>
                                );
                            }

                            if (pageNumber === currentPage - pageOffset - 1 ||
                                pageNumber === currentPage + pageOffset + 1) {
                                return (
                                    <Pagination.Ellipsis
                                        disabled
                                        key={`ellipsis-${pageNumber}`} />
                                );
                            }

                            return null;
                        })}

                        <Pagination.Next
                            onClick={() => setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages} />
                        <Pagination.Last
                            onClick={() => setCurrentPage(totalPages)}
                            disabled={currentPage === totalPages} />
                    </>
                )}
            </Pagination>

            {/* Informações adicionais se os indices forem diferentes */}
            {indexOfFirst !== undefined && indexOfLast !== undefined && indexOfFirst !== indexOfLast && (
                <div className="text-center mt-2">
                    <small className="text-muted">
                        {t.showing} {indexOfFirst + 1}-{Math.min(indexOfLast, lengthTotal)} {t.of} {lengthTotal} {tItemName}
                    </small>
                </div>
            )}
        </div>
    );
};

export default PaginationComponent;
